import { readProjectModels } from 'serviceWorker/broadcasts/project/all';
import { createEntityByIdSource } from 'serviceWorker/channelServers/entitySource';
import * as dbProjects from 'serviceWorker/db/projects/projects';
import * as dbProjectsService from 'serviceWorker/db/projects/projectsService';
import { projectEntityToModel } from 'shared/domain/project/mapping/toModel';
import { projectContract } from 'shared/domain/project/projectContract';
import { projectsSync } from './index';

/**
 * Projects of IndexedDB, archived ones included. A read downloads only a
 * missing list, as the legacy reads did; `sync` downloads the list again.
 */
export const projectSource = createEntityByIdSource({
  service: dbProjectsService,
  contract: projectContract,
  ...projectsSync,
  refreshAfterRead: projectsSync.downloadWhenMissing,
  readAll: readProjectModels,
  readOne: async (id) => {
    const project = await dbProjects.getOne(id);
    return project && projectEntityToModel(project);
  },
});
